import React, { useState, useEffect } from "react";
import { Box, Stack, Tooltip } from "@mui/material";
import EditIcon from '@mui/icons-material/Edit';
import { localStorageWithExpiry } from '../../utils/localStorageWithExpiry';

const LineupNameEditor = ({sportsbook, lineupId = 1, slateId, canEdit = true, ...restProps }) => {
    const [isEditting, setIsEditting] = useState(false);
    let localStorageKey = `lineupBuilderName-${sportsbook}-${slateId}-${lineupId}`

    // Clear expired items on component mount
    useEffect(() => {
        localStorageWithExpiry.clearExpired('lineupBuilderName');
    }, []);

    // initialize the state from localStorage if it exists; otherwise, use "Lineup <id>"
    const [title, setTitle] = useState(() => {
        return localStorageWithExpiry.getItem(localStorageKey) || `Lineup ${lineupId}`;
    });

    const handleTitleChange = (e) => {
        setTitle(e.target.value);
    };

    const handleKeyDown = (event) => {
        if (event.key === 'Enter') {
            setIsEditting(false)
        }
    };

    // updates title storage key value on title change
    useEffect(() => {
        localStorageWithExpiry.setItem(localStorageKey, title, 336);
    }, [title]);


    // get saved lineup name if its in storage
    useEffect(() => {
        localStorageKey = `lineupBuilderName-${sportsbook}-${slateId}-${lineupId}`
        const savedTitle = localStorageWithExpiry.getItem(localStorageKey);

        if (savedTitle) {
            setTitle(savedTitle)
        } else {
            setTitle(`Lineup ${lineupId}`)
        }
    },[lineupId, sportsbook, slateId]);

    return (
        <Stack direction='row' overflow='hidden' alignItems='center' flexGrow={1} gap='15px' {...restProps}>
            <Box maxWidth='100%' whiteSpace='nowrap' overflow='hidden' textOverflow='ellipsis'>
                {
                    isEditting ? (
                        <input
                            type="text"
                            value={title}
                            onChange={handleTitleChange}
                            placeholder="Enter new title"
                            onKeyDown={handleKeyDown}
                            onBlur={() => setIsEditting(false)}
                        />
                    ) : (
                        <>
                            {title}
                        </>
                    )
                }
            </Box>
            <Tooltip title="Edit the name of your entry">
                <span>
                    { canEdit  && <EditIcon onClick={() => setIsEditting(prev => !prev)} /> }
                </span>
            </Tooltip>
        </Stack>
    );
}

export default LineupNameEditor;